export default __webpack_public_path__ + "static/media/2.de55b2b6.png";